const experimentConfig = {
  globalExperiment: {
    experimentId: 'Q4KMAh3BQ4qNUNsdMXdprg',
    running: true,
    loadingCover: true,
    sites: [
      'themeforest',
      'graphicriver',
      'codecanyon',
      'photodune',
      '3docean',
      'videohive',
      'audiojungle'
    ],
    variantsWeights: [1, 9],
    variants: {
      0: {
        globalExperiment: false,
        homepageNewDesign: false
      },
      1: {
        globalExperiment: true,
        homepageNewDesign: true,
        categoryPageBlocksB: true
      }
    }
  },
  newHomepageExperiment: {
    experimentId: 'eCQGElkrSVqkXjHjD14dBg',
    running: true,
    sites: [
      'codecanyon',
      'videohive',
      'graphicriver',
      'audiojungle',
      'photodune',
      '3docean'
    ],
    loadingCover: true,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {
        homepageNewDesign: false
      },
      1: {
        homepageNewDesign: true
      }
    }
  },
  categoryNavigationExperiment: {
    experimentId: 'nvLSKFZ4R-Gxwbwjn6pSYw',
    running: false,
    sites: [
      'themeforest',
      'codecanyon',
      'videohive',
      'graphicriver',
      'audiojungle',
      'photodune',
      '3docean'
    ],
    loadingCover: true,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {
        smallIconsNavigation: false,
        textTableNavigation: false,
        viewMoreToggle: false
      },
      1: {
        smallIconsNavigation: true,
        textTableNavigation: false,
        viewMoreToggle: true
      },
      2: {
        smallIconsNavigation: true,
        textTableNavigation: false,
        viewMoreToggle: false
      },
      3: {
        smallIconsNavigation: false,
        textTableNavigation: true,
        viewMoreToggle: true
      },
      4: {
        smallIconsNavigation: false,
        textTableNavigation: true,
        viewMoreToggle: false
      }
    }
  }
}

export default experimentConfig
